// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { TBillingReport } from '../../types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  billing_report: {} as TBillingReport,
};

export const slice = createSlice({
  name: STORE_SLICES.BILLING_REPORT_DATA,
  initialState,
  reducers,
});

const billingReportDataActions = slice.actions;

const billingReportDataPersistConfig = {
  key: PERSIST_KEYS.BILLING_REPORT_DATA,
  storage,
};

export { billingReportDataActions, initialState };
export default persistReducer(billingReportDataPersistConfig, slice.reducer);
